import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Pagination } from '../models/pagination';
import { Payment } from '../models/payment';
import { FilterPaymentsForm } from '../pages/CreatePayment/FilterPayments';

const baseUrl = '/payments';

const getPayments = (
  data?: FilterPaymentsForm | { talents: number[] },
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Payment>>> =>
  axios.post<Pagination<Payment>>(baseUrl + '/filter', data, config);

const createPayments = (
  // eslint-disable-next-line
  payments: any[],
  config?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => axios.post<void>(baseUrl, payments, config);

const exportPayments = (
  data?: FilterPaymentsForm
): Promise<AxiosResponse<string>> =>
  axios.post(`${baseUrl}/export`, data, { responseType: 'blob' });

export const paymentService = {
  getPayments,
  createPayments,
  exportPayments
};
